import api, { AppFormItem as AppFormItemProps } from 'api'
import { AppTabs } from 'components/AppTabs'
import React, { Fragment, useContext, useEffect, useState } from 'react'

import { AppPageLayoutDesigerContext } from './AppPageLayoutDesigerContext'
import { PropertyForm, EmptyPropertyForm } from '../AppGridLayoutDesiger/PropertyForm'
import { SelectPageComponent } from './SelectPageComponent'
import { AppPageLayout } from '../../../../api/index'
import { PageDesiger } from '../PageDesiger'
import { Icon } from 'antd'
import { number } from 'prop-types'

export const AppPageLayoutBodyDesiger = () => {
	const renderBody = () => {
		const context = useContext(AppPageLayoutDesigerContext)
		switch (context.view) {
			case '页面设计':
				return <Desiger />
			default:
				return <Desiger />
		}
	}
	return (
		<div className="app-page-layout-body-desiger">
			<div className="app-page-layout-body-inner">{renderBody()}</div>
		</div>
	)
}
const Desiger = () => {
	return (
		<div className="app-page-layout-body-desiger">
			<MainDesiger />
			<MainProperty />
		</div>
	)
}

const MainDesiger = () => {
	return (
		<div className="app-page-layout-body-main-desiger">
			<div className="app-page-layout-body-main-inner">
				<div className="page-desiger" style={{ minHeight: '100%' }}>
					<PageLayoutColumn />
				</div>
			</div>
		</div>
	)
}

const PageFlexLayoutInner = (props: { index: number }) => {
	const context = useContext(AppPageLayoutDesigerContext)
	let appPage = context.appPage
	const delComponent = (index: number) => {
		appPage.appPageLayoutList.splice(index, 1)
		context.setAppPage({ ...appPage })
	}
	return (
		<div className="page-flex-layout-cell-box">
			<div
				className={`page-flex-layout-drop-zone ${
					context.currSelectd.field === props.index.toString() ? 'page-flex-layout-drop-zone-active' : ''
				}`}
			>
				<div className="page-flex-layout-cell-control widget-drag-handle">
					<div className="page-flex-layout-cell-control-toolbar">
						{appPage.appPageLayoutList.length > 1 ? (
							<span title="删除" className="page-flex-layout-cell-control-remove">
								<Icon type="close" className="remove" onClick={e => delComponent(props.index)}></Icon>
							</span>
						) : (
							''
						)}
					</div>
					<div className="cell-control-layout">
						<div className="cell-control-layout-header">列表</div>
						<div className="cell-control-layout-body">
							{context.appPage.appPageLayoutList.length > props.index &&
							context.appPage.appPageLayoutList[props.index].metadataId ? (
								<PageDesiger {...context.appPage.appPageLayoutList[props.index]} />
							) : (
								<div className="cell-control-layout-placeholder">请从右侧属性面板选择组件</div>
							)}
						</div>
					</div>
				</div>
			</div>
		</div>
	)
}

const PageFlexLayoutSider = () => {
	const context = useContext(AppPageLayoutDesigerContext)
	let appPageLayout = context.appPage.appPageLayoutList[0]
	return (
		<div
			className="page-flex-layout-cell page-flex-layout-cell-cells"
			style={{ width: appPageLayout.width || 300, height: '100%', minHeight: '200px' }}
			onClick={e => context.setCurrSelected({ type: 'component', field: '0' })}
		>
			<div className="page-flex-layout-cell-box" style={{ display: 'flex', flexDirection: 'column' }}>
				<div
					className="flex-cell-sortable page-flex-layout-cell"
					style={{ width: '100%', height: '100%', minHeight: '200px' }}
				>
					<PageFlexLayoutInner index={0} />
				</div>
			</div>
		</div>
	)
}

const PageFlexLayoutCell = (props: { index: number }) => {
	const context = useContext(AppPageLayoutDesigerContext)
	let appPageLayout = context.appPage.appPageLayoutList[props.index]
	return (
		<div
			className="page-cell-sortable page-flex-layout-cell"
			style={
				(appPageLayout.height || 400) === -1
					? { width: '100%', flex: '0.9 1 0%', minHeight: '100px' }
					: { width: '100%', height: appPageLayout.height || 400, minHeight: '100px' }
			}
			onClick={e => context.setCurrSelected({ type: 'component', field: props.index.toString() })}
		>
			<PageFlexLayoutInner index={props.index} />
		</div>
	)
}

const PageLayoutColumn = () => {
	const context = useContext(AppPageLayoutDesigerContext)
	let appPage = context.appPage
	let layoutType = appPage.layoutType || 1
	const addComponent = () => {
		appPage.appPageLayoutList.push({})
		context.setAppPage({ ...appPage })
	}
	return (
		<div
			className="page-flex-layout"
			style={{ flexDirection: layoutType === 1 ? 'column' : 'row', minHeight: 'calc(100% - 60px)' }}
		>
			{layoutType === 2 ? <PageFlexLayoutSider /> : ''}
			<div
				className="page-flex-layout-cell page-flex-layout-cell-cells page-flex-layout-cell-extensible"
				style={{ width: '100%', height: '100%', minHeight: '200px' }}
			>
				<div className="page-flex-layout-cell-box" style={{ display: 'flex', flexDirection: 'column' }}>
					{appPage.appPageLayoutList &&
						appPage.appPageLayoutList.map((appPageLayout: AppPageLayout, index: number) => {
							if (index === 0 && layoutType === 2) {
								return <Fragment />
							}
							return <PageFlexLayoutCell key={index} index={index} />
						})}

					<div className="page-flex-layout-cell-add">
						<div className="page-flex-layout-drop-zone page-flex-layout-drop-zone-extensible">
							<div className="page-flex-layout-cell-empty" title="点击新增组件" onClick={addComponent}>
								<Icon type="plus" className="page-flex-layout-cell-add-icon" />
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	)
}

const MainProperty = () => {
	const [propertyType, setPropertyType] = useState(0)
	const context = useContext(AppPageLayoutDesigerContext)
	const [tabKey, setTabKey] = useState(Math.random())
	useEffect(() => {
		chgPropertyType(0)
		setTabKey(Math.random())
	}, [context.currSelectd])
	const chgPropertyType = (index: number) => {
		setPropertyType(index)
	}
	return (
		<div className="app-page-layout-body-main-propert">
			<AppTabs key={tabKey} tabs={['组件属性', '控件属性']} defaultIndex={0} onChange={chgPropertyType}></AppTabs>
			{propertyType === 0 ? <ComponentProperty /> : <PageProperty />}
		</div>
	)
}

// interface PropertyProps {}
const PageProperty = () => {
	const context = useContext(AppPageLayoutDesigerContext)
	let formData = {
		name: context.appPage.name,
		title: context.appPage.title,
	}
	const [entityList, setEntityList] = useState([])
	const loadEntityList = async () => {
		let res = await api.modeling.entity.getList({ systemCode: '00' })
		setEntityList(res)
	}
	const chgPageProperty = (propertyFormItem: AppFormItemProps, value: any, label?: string) => {
		let chgData =
			label && propertyFormItem.textField
				? { [propertyFormItem.field]: value, [propertyFormItem.textField]: label }
				: { [propertyFormItem.field]: value }
		let appPage = context.appPage
		formData = {
			...formData,
			...chgData,
		}

		appPage.name = formData.name

		context.setAppPage({ ...appPage })
	}
	useEffect(() => {
		loadEntityList()
	}, [])
	let propertyFormItemList = [
		{ field: 'name', isSave: true, req: true, label: '列表名称', type: 'Input' },
		{ field: 'title', isSave: true, req: true, label: '标题', type: 'Input' },
	] as AppFormItemProps[]
	return <PropertyForm formData={formData} onChange={chgPageProperty} propertyFormItemList={propertyFormItemList} />
}

const ComponentProperty = () => {
	const context = useContext(AppPageLayoutDesigerContext)

	const rendComponentProperty = () => {
		switch (context.currSelectd.type) {
			case 'component':
				return (
					<ComponentSetProperty key={context.currSelectd.field + context.appPage.appPageLayoutList.length} />
				)
			default:
				return (
					<ComponentSetProperty key={context.currSelectd.field + context.appPage.appPageLayoutList.length} />
				)
		}
	}
	return <Fragment>{rendComponentProperty()}</Fragment>
}

const ComponentSetProperty = () => {
	const context = useContext(AppPageLayoutDesigerContext)
	let appPageLayout = context.appPage.appPageLayoutList[context.currSelectd.field] as AppPageLayout
	if (!appPageLayout) return <EmptyPropertyForm />
	let formData = {
		id: appPageLayout.id,
		metadataId: appPageLayout.metadataId,
	}
	const chgMetadataId = (selectedOptions: any) => {
		let appPage = context.appPage
		appPageLayout.metadataId = selectedOptions.id
		appPageLayout.type = selectedOptions.type
		appPageLayout.application = selectedOptions.application
		context.setAppPage({ ...appPage })
	}
	const chgProperty = (propertyFormItem: AppFormItemProps, value: any, label?: string) => {
		let appPage = context.appPage
		let chgData =
			label && propertyFormItem.textField
				? { [propertyFormItem.field]: value, [propertyFormItem.textField]: label }
				: { [propertyFormItem.field]: value }
		formData = {
			...formData,
			...chgData,
		}
		appPageLayout.id = formData.id
		context.setAppPage({ ...appPage })
	}
	let propertyFormItemList = [
		{ field: 'id', isSave: true, req: true, label: '组件ID', type: 'Input' },
		{
			field: 'componentId',
			isSave: true,
			req: true,
			label: '选择组件',
			dataType: 'number',
			render: <SelectPageComponent application="00" style={{ width: '100%' }} onChange={chgMetadataId} />,
		},
	] as any[]
	return <PropertyForm formData={{}} propertyFormItemList={propertyFormItemList} onChange={chgProperty} />
}



// WEBPACK FOOTER //
// ./src/modules/modeling/page/AppPageLayoutDesiger/AppPageLayoutBodyDesiger.tsx